var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c("Card", { staticClass: "event" }, [
        _c("p", { staticClass: "event_title" }, [_vm._v(_vm._s(_vm.title))]),
        _c("p", { staticClass: "event_datetime" }, [
          _vm._v(
            " " +
              _vm._s(_vm._f("moment")(_vm.start, "dd")) +
              ". " +
              _vm._s(_vm._f("moment")(_vm.start, "D")) +
              ". " +
              _vm._s(_vm._f("moment")(_vm.start, "MMMM")) +
              " " +
              _vm._s(_vm._f("moment")(_vm.start, "Y")) +
              " "
          ),
          !_vm.isAllDay
            ? _c("span", { staticClass: "event_time" }, [
                _c("br"),
                _vm._v(
                  " um " + _vm._s(_vm._f("moment")(_vm.start, "H:mm")) + " Uhr "
                ),
              ])
            : _vm._e(),
        ]),
        _vm.location
          ? _c(
              "div",
              { staticClass: "event_location" },
              [_c("Location", { attrs: { location: _vm.location } })],
              1
            )
          : _vm._e(),
        _vm.description
          ? _c("span", { staticClass: "event_description" }, [
              _vm._v(_vm._s(_vm.description)),
            ])
          : _vm._e(),
        _c("br"),
        _vm.location
          ? _c("span", { staticClass: "event_location_address" }, [
              _c("br"),
              _vm.isIOS || _vm.isMacOS
                ? _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href: "http://maps.apple.com/?daddr=" + _vm.location,
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "event-direction_icon",
                        style: { color: "white" },
                        attrs: { icon: "directions" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAndroid
                ? _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href:
                          "https://www.google.com/maps/dir/?api=1&destination=" +
                          _vm.location,
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "event-direction_icon",
                        style: { color: "white" },
                        attrs: { icon: "directions" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isWinPhone
                ? _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href: "ms-drive-to:?destination.name=" + _vm.location,
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "event-direction_icon",
                        style: { color: "white" },
                        attrs: { icon: "directions" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isMobile && !_vm.isMacOS
                ? _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href:
                          "https://www.google.com/maps/dir/?api=1&destination=" +
                          _vm.location,
                        target: "_blank",
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "event-direction_icon",
                        style: { color: "white" },
                        attrs: { icon: "directions" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("br"),
              _vm._v(" " + _vm._s(_vm.location) + " "),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }